import React, { PureComponent } from 'react';
import ButtonHeader from './ButtonHeader';

class ButtonHeaderGrey extends PureComponent {
    state = {};

    render() {
        let { classes = [], ...props } = this.props;
        let finalClasses = ['fm-button__header-grey', ...classes];
        return <ButtonHeader {...props} classes={finalClasses} />;
    }
}

export default ButtonHeaderGrey;
